export const SITE_PROTOCOL = 'https'

export const GLOBAL_CHAT_ID = 'GLOBAL_CHAT_ID'
export const GLOBAL_CHAT_ID_ALTERNATIVE = 'global-chat-room'
